// What Camille SAYS for a reply (client QA, 10 Oct). The text on screen is
// never changed; only the spoken copy:
//   - never URLs, email addresses, markdown, code, slashes or hyphen runs, the
//     "Sources:" list or the "— <LLM> (<version>)" signature;
//   - a long reply is spoken as its first one or two sentences, then "The full
//     answer is on your screen."
export const LONG_REPLY_CHARS = 280;
const MAX_SPOKEN_CHARS = 240;
export const FULL_ANSWER_LINE = "The full answer is on your screen.";

export function cleanForSpeech(text) {
  let t = String(text || "");
  t = t.replace(/```[\s\S]*?```/g, " ");                       // code blocks
  t = t.replace(/`[^`\n]*`/g, " ");                             // inline code
  t = t.replace(/\n\s*Sources:\s*\n[\s\S]*$/i, "");             // the sources list (and what follows it)
  t = t.replace(/\n\s*—\s[^\n]*$/, "");                          // the "— LLM (version)" signature
  t = t.replace(/!\[[^\]]*\]\([^)]*\)/g, " ");                   // markdown images
  t = t.replace(/\[([^\]]+)\]\([^)]*\)/g, "$1");                 // markdown links -> their text
  t = t.replace(/\b(?:https?:\/\/|www\.)\S+/gi, " ");            // URLs
  t = t.replace(/\b[\w.+-]+@[\w-]+(?:\.[\w-]+)+\b/g, " ");       // email addresses
  t = t.replace(/\b[\w-]+(?:\.[\w-]+)*\.(?:com|org|net|io|ai|co|gov|edu|uk|info)(?:\/\S*)?/gi, " "); // bare domains
  t = t.replace(/^\s{0,3}#{1,6}\s*/gm, "");                      // headings
  t = t.replace(/^\s*(?:[-*+•]|\d+[.)])\s+/gm, "");              // list markers
  t = t.replace(/^\s*\|?[\s:|-]+\|[\s:|-]*$/gm, " ");            // table rules
  t = t.replace(/[*_~#>|`]+/g, " ");                             // emphasis, quotes, table bars
  t = t.replace(/[\\/]+/g, " ");                                 // slashes
  t = t.replace(/(?:-{2,}|—{2,}|–{2,}|={2,}|\.{4,})/g, " ");     // hyphen and other runs
  t = t.replace(/\s+([.,!?;:])/g, "$1");
  return t.replace(/\s+/g, " ").trim();
}

function firstSentences(text, count) {
  const parts = text.match(/[^.!?]+[.!?]+(?=\s|$)|[^.!?]+$/g) || [text];
  let out = "";
  for (const p of parts.slice(0, count)) {
    const next = (out + " " + p.trim()).trim();
    if (out && next.length > MAX_SPOKEN_CHARS) break;
    out = next;
  }
  if (out.length > MAX_SPOKEN_CHARS) {
    out = out.slice(0, MAX_SPOKEN_CHARS).replace(/\s+\S*$/, "").replace(/[,;:]$/, "") + ".";
  }
  return out;
}

export function spokenText(text) {
  const clean = cleanForSpeech(text);
  if (!clean) return String(text || "").trim() ? FULL_ANSWER_LINE : "";
  if (clean.length <= LONG_REPLY_CHARS) return clean;
  return `${firstSentences(clean, 2)} ${FULL_ANSWER_LINE}`;
}
